// extracted by mini-css-extract-plugin
module.exports = {"filters":"ShopReview_filters___IuiJ","rate":"ShopReview_rate__3tF10","textfield":"ShopReview_textfield__3rCP0"};